import React from 'react';
import { getTranslation } from "./i18n";

var Statistics = React.createClass({
  render: function() {
    return(
      <div style={{minWidth: "17rem"}} className="flex bg-base-200 py-2 px-3 rounded-box mt-4 justify-center" >
        <div className="half text-right" style={{color: '#e26b6b'}}>
          {getTranslation(this.props.locale, "you")}<br/>
          { (this.props.board.map( function(row){return(row.join(''))} ).join('').match(/r/g) || []).length} {getTranslation(this.props.locale, "soldiers")}<br/>
          { (this.props.board.map( function(row){return(row.join(''))} ).join('').match(/r\sk/g) || []).length} {getTranslation(this.props.locale, "kings")}
        </div>
        <div className="divider divider-horizontal"></div>
        <div className="half">
          {getTranslation(this.props.locale, "enemy")}<br/>
          { (this.props.board.map( function(row){return(row.join(''))} ).join('').match(/b/g) || []).length} {getTranslation(this.props.locale, "soldiers")}<br/>
          { (this.props.board.map( function(row){return(row.join(''))} ).join('').match(/b\sk/g) || []).length} {getTranslation(this.props.locale, "kings")}
        </div>
      </div>
    )
  }
});

export default Statistics;


// WEBPACK FOOTER //
// ./src/Statistics.js